import { useCallback, useState } from 'react';

/**
 * Состояние листа, который открывают для конкретной записи. Запись не
 * обнуляется при закрытии: лист ещё доигрывает анимацию выхода, и без неё
 * содержимое на глазах сменилось бы на пустую форму или лист исчез бы рывком.
 */
export function useSheetState<T>(): {
  value: T | null;
  open: boolean;
  show: (value: T) => void;
  close: () => void;
} {
  const [value, setValue] = useState<T | null>(null);
  const [open, setOpen] = useState(false);
  const show = useCallback((next: T) => {
    setValue(next);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  return { value, open, show, close };
}
